<template>

<div>
  <CRUDDialog ref="crudDialog" :baseCrudKey="baseCrudKey" dialogDynamicWidth="300"
    dialogHeaderName="Fund" :canSave="true" @upsertItem="upsertFundInfo">
    <template v-slot:[`editedItem`]="{ }">
      <template class="">
        <div class="scrollable-ctnr pb-0 ma-0">
          <v-row dense justify="space-around" class="">
            <v-col cols="12" class="pt-0 pb-0 " >
              <v-text-field class="input-text-size my-n2 py-n2"
              v-model="editedItem.fund"
          label="Fund#"
        ></v-text-field>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <v-textarea class="input-text-size pt-0 pb-0"
              v-model="editedItem.description"  rows="2"
                label="Description">
              </v-textarea>
            </v-col>
          </v-row>
        </div>
      </template>

    </template>
  </CRUDDialog>
 </div>

</template>

<script>
import {
  mapMutations, mapGetters, mapActions,
} from 'vuex';

import CRUDDialog from '../../../common/base/crud-2.0/CRUDDialog.vue';
import { isProtestFund } from '../../../shared/shared.util';
import { toFiscalYear } from '../../../../util/shared/tmc-global';
import { TAX_CONSTANTS } from '../../common-utils/constants';

export default {
  name: 'ProtestTaxFundDialog',
  components: {
    CRUDDialog,

  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },

  },

  data: () => ({
    fundAddCrudKey: 'ProtestTaxFundDialog',
    fund: '',
    description: '',
    fiscalYear: toFiscalYear(new Date()),

  }),

  computed: {
    ...mapGetters('base/crud', ['item', 'items']),

    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },

  },
  methods: {
    ...mapActions('shared/fund', [
      'loadFunds', 'upsertFund',
    ]),
    ...mapMutations('base/crud', ['setIsVisible', 'setItem', 'setItems']),

    async  upsertFundInfo() {
      const fundCrudKey = 'sharedFund';
      if (isProtestFund(parseInt(this.editedItem.fund, 10))) {
        const item = {
          fiscalYear: this.fiscalYear,
          fund: this.editedItem.fund,
          description: this.editedItem.description,
          type: 'CASHFUND',

        };
        await this.upsertFund({
          item,
          fundCrudKey,
          postProccessFunds: (dataItems) => dataItems.map((dataItem) => ({
            ...dataItem,

          })),

        }).then(async () => {
          await this.loadFunds({
            criteria: {
              fiscalYear: this.fiscalYear,
              sortBy: [
                {
                  column: 'fund',
                  direction: 'asc',
                },
              ],
            },
            baseCrudKey: 'sharedFund',
          });
          const items = this.items('sharedFund');
          const funds = items.filter((f) => isProtestFund(parseInt(f.fund, 10)));
          this.setItems(['sharedFund', funds]);
          // this.populateFundSuggestion();
        });
      } else {
        const message = `Fund no between ${TAX_CONSTANTS.PROTESTFUND.MIN} to ${TAX_CONSTANTS.PROTESTFUND.MAX} reserved for protest`;
        alert(message);
      }
    },

    dataFromCommonDropDowns(val) {
      this.taxYear = val;
    },

    loadFundData() {
      this.loadFunds({
        criteria: {
          fiscalYear: this.fiscalYear,
          sortBy: [
            {
              column: 'fund',
              direction: 'asc',
            },
          ],
        },
        baseCrudKey: 'sharedFund',
      });
    },

  },
};
</script>
